module.exports = __webpack_public_path__ + "img/4.cad33d06.png";